module.exports = __webpack_public_path__ + "static/media/logo_hyponav_beta_white.f94c97db.svg";